import { SideNav, SideNavContent } from "components";
import PageHeader from "components/UniversalComponents/PageHeader";
import { HeaderDasNew, MainBody, OverlayLoader } from "components/core";
import { WidthLimiter } from "pages/PlanSetup/styles";
import React, { useEffect, useMemo, useState } from "react";
import http from "services/httpService";
import styled from "styled-components";
import ServicingManager from "pages/ClaimSupport/ServicingManager";
import TextInline from "pages/ClaimSupport/TextInline";
import Level from "pages/ClaimSupport/level";
import useFetchSupport from "./useFetchSupport";
import BaseBreadcrumbs from "components/core/BaseBreadcrumbs";
import { useSearchParams } from "react-router-dom";
import { FLEX_PRODUCTS } from "constants";

function ClaimSupport() {
  const [params] = useSearchParams();
  const { support, tpaName, loading } = useFetchSupport(params.get("userplan"));

  const cashlessClaims = useMemo(() => {
    if (
      !support ||
      !support.claims_details ||
      !support.claims_details.cashless_details
    )
      return [];
    const detail = Object.groupBy(
      support.claims_details.cashless_details,
      ({ cashless_level }) => cashless_level
    );
    return Object.values(detail);
  }, [support]);

  const escalationDetails = useMemo(() => {
    if (
      !support ||
      !support.claims_details ||
      !support.claims_details.escalation_details
    )
      return [];

    const detail = Object.groupBy(
      support.claims_details.escalation_details,
      ({ escalation_level }) => escalation_level
    );
    return Object.values(detail);
  }, [support]);

  const neoManagers = useMemo(() => {
    if (!support) return [];
    if (
      support.relationship_manager.length > 0 ||
      support.servicing_manager.length > 0
    ) {
      return [...support.servicing_manager, ...support.relationship_manager];
    }
  }, [support]);

  const RenderContacts = (header, cashlessClaim, data) => {
    return (
      <>
        <div style={{ marginTop: "5rem" }}>
          <PageHeader header={header} />
        </div>
        <Level data={data} cashlessClaim={cashlessClaim} />
      </>
    );
  };

  const crumbs = useMemo(() => {
    return [
      {
        name: "Dashboard",
        path: "/v1",
      },
      {
        name: FLEX_PRODUCTS[params.get("product")] || "",
        // path: `/v1?tab=${}`,
      },
      {
        name: "Claim Support",
        path: "/v1/claim-support",
        active: true,
      },
    ];
  }, []);

  if (loading) return <OverlayLoader />;

  return (
    <>
      <BaseBreadcrumbs breadcrumbs={crumbs} />
      {tpaName && (
        <WidthLimiter
          style={{
            overflow: "hidden",
            maxWidth: "1000px",
          }}
        >
          <PageHeader header="Administrator" />
          {tpaName && <TextInline name={tpaName} />}
          {cashlessClaims.length > 0 &&
            RenderContacts("Contact Details", "cashless", cashlessClaims)}
          {escalationDetails.length > 0 &&
            RenderContacts(
              "Escalation Matrix",
              "escalation",
              escalationDetails
            )}
        </WidthLimiter>
      )}
      {tpaName && <PageGap />}
      <WidthLimiter
        style={{
          maxWidth: "1000px",
        }}
      >
        <PageHeader
          header={"Contacts for Neo Risk Management and Insurance Broker"}
        />
        <ServicingManager data={neoManagers} />
      </WidthLimiter>
    </>
  );
}

export default ClaimSupport;

const PageGap = styled.div`
  height: 1px;
  margin: 86px 0px 52px 0px;
  position: relative;
  background-color: #dadada;
`;
